/* Product cards – variaties: prijs + submit-knop (per kaart) */
export function mount() {
  if (!window.jQuery) return;
  const $ = window.jQuery;

  // money formatter
  function formatMoney(n){
    const p = window.wc_price_params || {};
    const dec  = p.decimal_sep || ',';
    const thou = p.thousand_sep || '.';
    const prec = Number.isFinite(Number(p.precision)) ? Number(p.precision) : 2;
    const sym  = p.currency_symbol || '€ ';
    const fmt  = p.price_format || '%s%v';
    const fixed = Number(n).toFixed(prec);
    const parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
    const val = parts.join(dec);
    return fmt.replace('%s', sym).replace('%v', val);
  }

  function renderPrice($price, baseHTML, variation){
    if (!$price.length) return;
    if (variation && variation.price_html) {
      $price.html(variation.price_html);
      return;
    }
    if (variation && typeof variation.display_price !== 'undefined') {
      $price.html('<span class="amount">'+formatMoney(variation.display_price)+'</span>');
      return;
    }
    $price.html(baseHTML);
  }

  function initCard($form) {
    if ($form.data('wkCardInit')) return;
    $form.data('wkCardInit', true);

    // init Woo core script (voor zekerheid)
    if (typeof $form.wc_variation_form === 'function') {
      $form.wc_variation_form();
    }

    const $card   = $form.closest('.wk-product-card, .product, .wk-card');
    const $price  = $card.find('[data-card-price]').first();
    const $button = $card.find('[data-card-submit]').first();
    const baseHTML = ($card.find('[data-card-price-base]').first().html() || $price.html() || '').trim();

    function setBtn(state) {
      if (!$button.length) return;
      if (state === 'ready') {
        $button.prop('disabled', false).text($button.data('ready') || 'In winkelwagen');
      } else {
        $button.prop('disabled', true).text($button.data('select') || 'Selecteer opties');
      }
    }

    // unified handler
    const onVar = function (_e, variation) {
      // sommige plugins geven geen object mee → reconstructie via variation_id
      if (!variation) {
        const id = parseInt($form.find('input.variation_id').val(), 10);
        const all = $form.data('product_variations');
        if (Array.isArray(all) && id) {
          variation = all.find(v => parseInt(v.variation_id,10) === id) || null;
        }
      }
      renderPrice($price, baseHTML, variation);
      setBtn(variation ? 'ready' : 'select');
    };

    // 1) Standaard Woo events
    $form.on('found_variation show_variation reset_data hide_variation woocommerce_variation_has_changed', function(e, variation){
      if (e.type === 'reset_data' || e.type === 'hide_variation') {
        renderPrice($price, baseHTML, null);
        setBtn('select');
      } else {
        onVar(e, variation || null);
      }
    });

    // 2) Bekende swatch-plugin events
    $form.on('wvs-selected-item tawcvs_found_variation woo_variation_swatches_found_variation', function(e, variation){
      onVar(e, variation || null);
    });

    // 3) Fallback: wanneer verborgen variation_id wijzigt
    $form.on('input change', 'input.variation_id', function(){
      onVar($.Event('variation_id_change'), null);
    });

    // 4) Forceer check wanneer attribute inputs wijzigen (select/radio/image-swatch)
    $form.on('change', 'select[name^="attribute_"], input[name^="attribute_"]', function(){
      setTimeout(function(){ try { $form.trigger('check_variations'); } catch(e){} }, 0);
    });

    // Initial state
    const $varId = $form.find('input.variation_id');
    const already = $varId.length && parseInt($varId.val(), 10) > 0;
    if (already) {
      try { $form.trigger('show_variation', [{}]); } catch(e){}
      setBtn('ready');
    } else {
      setBtn('select');
      setTimeout(function(){ try { $form.trigger('check_variations'); } catch(e){} }, 0);
    }

    // Submit via kaartknop
    $button.on('click', function (e) {
      e.preventDefault();
      const ok = $varId.length && parseInt($varId.val(), 10) > 0;
      if (!ok) {
        try { $form.trigger('check_variations'); } catch(e){}
        const sel = $form.find('select[name^="attribute_"]').get(0);
        if (sel) sel.focus();
        return;
      }
      if (typeof $form[0].requestSubmit === 'function') $form[0].requestSubmit();
      else $form.trigger('submit');
    });
  }

  function scan(root) {
    (root ? $(root) : $(document))
      .find('.variations_form.cart[data-card-scope]')
      .each(function(){ initCard($(this)); });
  }

  $(function(){ scan(); });
  $(document).on('wc_fragments_loaded updated_wc_div quick-view-displayed wk_archive_cards_appended', function(e, ctx){
    scan(ctx && ctx.root ? ctx.root : null);
  });

  new MutationObserver(muts => {
    muts.forEach(m => m.addedNodes && m.addedNodes.forEach(node => {
      if (!(node instanceof HTMLElement)) return;
      if (node.matches && node.matches('.variations_form.cart[data-card-scope]')) initCard($(node));
      else if (node.querySelector) {
        const forms = node.querySelectorAll('.variations_form.cart[data-card-scope]');
        if (forms.length) scan(node);
      }
    }));
  }).observe(document.body, { childList:true, subtree:true });
}
